module.exports = "/images/avatar-s-10.jpg?c7eebd6b707086d0063fc288f3905042";